module.exports = {
    __lang__: 'zh-tw',
    exampleGreeting: '你好，組態器！更多工作待您完成。',
    currTime: '當前時間是：'
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locale.zh-tw.js
// module id = 6
// module chunks = 0